var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"legend-line"},[_c('v-btn',{staticClass:"legend"},[_c('v-icon',{attrs:{"color":_vm.color,"size":"18"}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"infobox"},[_c('p',[_vm._v(_vm._s(_vm.label))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }